<template>
  <v-dialog
    content-class="MyTooltip"
    v-model="dialog"
    persistent
    max-width="600px"
    style="z-index: 2000"
  >
    <!-- <v-tooltip bottom content-class="MyTooltip"> -->
    <template v-slot:activator="{ on, attrs }" @click="dialog = !dialog">
      <span v-bind="attrs" v-on="on" style="color: #2f80ed"> {{ text }}</span>
    </template>

    <template v-slot:default>
      <v-card class="mx-auto" max-width="100%" elevation="0">
        <v-btn icon color="#C0BEBE" class="closeBtn" @click="dialog = false">
          <v-icon class="fal fa-xmark"></v-icon>
        </v-btn>
        <v-card-text>
          <h2
            class="
              drawer-right__title
              my-0
              font-weight-bold
              text-center text-uppercase
            "
          >
            <translate>Ranking methodology</translate>
          </h2>
          <p class="primary--text mt-5 black--text text-justify" v-translate>Our algorithm technology combines ratings, number of reviews and followers from TripAdvisor, Google, Facebook, Instagram, Twitter, YouTube and our BGC platform to form our ranking. Each criterion gives a certain number of points which is weighted by the total number of Reviews and Followers on social networks.
          </p>
        </v-card-text>
      </v-card>
    </template>
  </v-dialog>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isMobile: false,
      dialog: false,
    };
  },

  methods: {},
};
</script>
<style lang="scss">
.MyTooltip {
  .closeBtn {
    float: right;
  }
  .v-card__text {
    padding: 24px !important;
  }
}
</style>
